// This is the javascript entrypoint for the main-collection section.
// This file and all its inclusions will be processed through postcss

import '@archetype-themes/scripts/config'
import '@archetype-themes/scripts/modules/collection-template';
import '@archetype-themes/scripts/helpers/sections';
